// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    DigitalLineCardData,
    DigitalLineCardParameter,
    getDigitalLineCardDataService,
} from "@mcmc/App/Services/DigitalLineCardService";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";

type HandlerType = ApiHandler<DigitalLineCardParameter, DigitalLineCardData>;

export const BeginLoadData: HandlerType = props => {
    props.dispatch({
        type: "xDigitalLineCard/BeginLoadData",
        parameter: props.parameter.categoryId,
        widgetId: props.parameter.widgetId,
    } as any);
};

export const SendDataToApi: HandlerType = async props => {
    const state = props.getState() as McMcApplicationState;
    if (state.xDigitalLineCard.dataViews?.[props.parameter.widgetId]?.[props.parameter.categoryId]) {
        (props as any).dispatch({
            type: "xDigitalLineCard/CancelLoadData" as any,
            widgetId: props.parameter.widgetId,
        });
        return false;
    }
    try {
        props.apiResult = await getDigitalLineCardDataService(props.parameter);
    } catch (error) {
        return false;
    }
};

export const CompleteLoadData: HandlerType = props => {
    props.dispatch({
        type: "xDigitalLineCard/CompleteLoadData",
        digitalCardLineData: props.apiResult,
        categoryId: props.parameter.categoryId,
        widgetId: props.parameter.widgetId,
    } as any);
};

export const chain = [BeginLoadData, SendDataToApi, CompleteLoadData];

const getDigitalLineCardData = createHandlerChainRunner(chain, "GetDigitalLineCardData");
export default getDigitalLineCardData;
